import React from 'react';
import { ArrowRight, Play } from 'lucide-react';
import '../Css_files/Homecont5.css';

const HomeCont5 = () => {
  return (
    <section id="home" className="HomeCont5-hero">
      <div className="HomeCont5-hero-container">
        <div className="HomeCont5-hero-content">
          <div className="HomeCont5-hero-text">
            <h1 className="HomeCont5-hero-title">
              Learn Anytime, Anywhere with 
              <span className="HomeCont5-highlight"> Profenaa Online</span>
            </h1>
            
            <p className="HomeCont5-hero-description">
              Upgrade your skills with world-class online courses in 
              <strong> Engineering, IT, Arts, and Multimedia</strong>. 
              Gain practical, job-ready knowledge from expert mentors, 
              and earn certifications that help you stand out globally.
            </p>

            <div className="HomeCont5-hero-buttons">
              <button className="HomeCont5-primary-button">
                Start Learning
                <ArrowRight className="HomeCont5-button-icon" />
              </button>
              <button className="HomeCont5-secondary-button">
                <Play className="HomeCont5-button-icon" />
                Watch Demo
              </button>
            </div>

            {/* Stats Section (optional – uncomment if needed) */}
            {/* <div className="HomeCont5-hero-stats">
              <div className="HomeCont5-stat">
                <span className="HomeCont5-stat-number">50,000+</span>
                <span className="HomeCont5-stat-label">Learners</span>
              </div>
              <div className="HomeCont5-stat">
                <span className="HomeCont5-stat-number">200+</span>
                <span className="HomeCont5-stat-label">Courses</span>
              </div>
              <div className="HomeCont5-stat">
                <span className="HomeCont5-stat-number">98%</span>
                <span className="HomeCont5-stat-label">Success Rate</span>
              </div>
            </div> */}
          </div>

          {/* Floating Cards for Features */}
          <div className="HomeCont5-hero-image">
            <div className="HomeCont5-floating-card card-1">
              <div className="HomeCont5-card-content">
                <div className="HomeCont5-card-icon">📚</div>
                <span>Interactive Learning</span>
              </div>
            </div>
            <div className="HomeCont5-floating-card card-2">
              <div className="HomeCont5-card-content">
                <div className="HomeCont5-card-icon">🎓</div>
                <span>Expert Mentors</span>
              </div>
            </div>
            <div className="HomeCont5-floating-card card-3">
              <div className="HomeCont5-card-content">
                <div className="HomeCont5-card-icon">🌍</div>
                <span>Global Certifications</span>
              </div>
            </div>
            <div className="HomeCont5-floating-card card-4">
              <div className="HomeCont5-card-content">
                <div className="HomeCont5-card-icon">💼</div>
                <span>Career Support</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeCont5;
